//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'AGED',
  data() {
    return {
      form: {
        item1: '',
        item2: '',
      },
      hasScore: false,
      disabled: false,
      text: ''
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res
        if (form.item1 >= 50) {
          res = form.item1 * 10
          if (form.item2 < res) {
            self.text = '阴性，排除血栓可能'
          } else {
            self.text = '阳性，考虑血栓可能'
          }
        } else {
          res = 500
          if (form.item2 < res) {
            self.text = '阴性，排除血栓可能'
          } else {
            self.text = '阳性，考虑血栓可能'
          }
        }
        self.hasScore = true
        return String(res)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/AGED.vue